module.exports = __webpack_public_path__ + "static/img/zhanting.8c2ae244.png";